import React, {useState} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import {setCurrentStep, setServiceToTransfer, setCurrentPopUp, submitServiceValidation} from '../OwnershipTransferSellerSlice';
import {OwnershipTransferPrivateSellerStep, ServiceType, ProductType, PopupMessageContent} from '../Constant/Constant';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';
import EasyTransferMessage from '../Shared/EasyTransferMessage';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import ImportantToKnowItem from '../Shared/ImportantToKnowItem';

const SelectCellularNumber = (props) => {
  const [error, setError] = useState(false);

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails},
        actionType: DwhActionType.SelectLineAddressPage,
        messageText: DWHMessageText.SelectLineAddressPageDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  function submitServiceValidation() {
    if (props.data.serviceToTransfer == null) {
      setError(true);
    } else if (
      !props.data.serviceToTransfer.assetExternalId?.trim() ||
      (props.data.serviceToTransfer.accountType != 'I' && props.data.serviceToTransfer.accountType != 'S')
    ) {
      props.setCurrentPopUp(PopupMessageContent.CellularGeneralTransferError);
    } else {
      gaButtonClick();
      //validate selection
      let product = {
        AssetExternalId: props.data.serviceToTransfer.assetExternalId,
        SubscriberNo: props.data.serviceToTransfer.subscriberNumber,
      };

      props.submitServiceValidation(product);
    }
  }
  function getGeneralSelectBoxOptions() {
    const generalSelectBoxOptions = [];
    props.productsAndServices?.Cellular?.map((phone) => {
      generalSelectBoxOptions.push({key: phone.subscriberNumber, value: phone});
    });

    // Iterate through Bundle array and extract Cellular items from each bundle
    props.productsAndServices?.Bundle?.forEach((bundle) => {
      bundle.cellularItem?.forEach((phone) => {
        const phoneWithAccountType = {...phone, accountType: bundle.accountType};
        generalSelectBoxOptions.push({key: phone.subscriberNumber, value: phoneWithAccountType});
      });
    });

    return generalSelectBoxOptions;
  }

  function saveSelectedService(selectedItem) {
    props.setServiceToTransfer({
      item: selectedItem,
      productType: ProductType.Cellular,
    });
  }

  function gaButtonClick() {
    dwhGeneralReport({
      data: {...props.data, userDetails: props.userDetails},
      actionType: DwhActionType.SelectLineAddressPage,
      messageText: DWHMessageText.SelectLineAddressPageButtonClicked,
      status: DWHStatus.Ongoing,
    });
  }

  return (
    <div className='ownership-transfer-select-phone-number ownership-transfer-step'>
      {getGeneralSelectBoxOptions()?.length > 1 ? (
        <div className='l-title '>
          איזה כיף! <br />
          יש לכם כמה מנויי סלולר{' '}
        </div>
      ) : (
        <div className='l-title '>העברת בעלות</div>
      )}
      <div className='m-title center'>איזה קו תרצו להעביר בעלות?</div>
      <div className='stepContainer'>
        <SelectList options={getGeneralSelectBoxOptions()} onClick={(e) => saveSelectedService(e)} />

        <EasyTransferMessage />
        {props.iContent.importantListCellular?.expandedValue?.length > 0 &&
          props.iContent.importantListCellular?.expandedValue[0].itemList?.expandedValue.length > 0 && (
            <div className='important-to-know'>
              <div className='m-title semi'>{props.iContent.importantListCellular?.expandedValue[0].title.value}</div>
              {props.iContent.importantListCellular?.expandedValue[0].itemList?.expandedValue?.map((item, index) => {
                return <ImportantToKnowItem item={item} index={index} />;
              })}
            </div>
          )}
      </div>

      <div className='continue-button'>
        {error && <div className='error center'>כדי להמשיך יש לבחור מספר </div>}
        <BtnSubmit onclick={submitServiceValidation} text={'המשך'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateSeller,
  productsAndServices: state.selfcarePage.productsBySubscriber,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  setServiceToTransfer,
  setCurrentPopUp,
  submitServiceValidation,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCellularNumber);
